import type { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { scheduleExpectationsChannelName } from '@/channels/utils/channelNames';

import type { Props } from './types';

const ScheduleExpectationsChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={scheduleExpectationsChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default ScheduleExpectationsChannel;
